<!--
     Copyright (c) 2024-2026 Broadcom. All Rights Reserved.
     Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
     and/or its subsidiaries.
-->
<clr-combobox-container>
    <clr-combobox (clrSelectionChange)="onSelectionChange($event)"
                  [(ngModel)]="selectedItem"
                  #combobox
                  name="subType"
                  required>
        <clr-options>
            <clr-option *clrOptionItems="let item of items; field: 'label'"
                        [clrValue]="item">
                {{ item.label }}
            </clr-option>
        </clr-options>
    </clr-combobox>
</clr-combobox-container>
